import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

function Root(): React.JSX.Element {
  const path = useRouterState({ select: (s) => s.location.pathname });

  // NOT ON THE PREVIEW PAGE. `/preview/{token}` is the thing an author SCANS WITH A PHONE — it is a
  // device surface, not a dashboard page, and the router devtools badge was sitting on top of the
  // experience they came to look at. Dev-only was not a narrow enough rule: this page is
  // user-facing *in dev*, which is the only place it is ever used.
  const isDeviceSurface = path.startsWith('/preview/');

  return (
    <>
      <div className="min-h-screen bg-background">
        <Outlet />
      </div>
      {import.meta.env.DEV && !isDeviceSurface && (
        <>
          <TanStackRouterDevtools />
          <ReactQueryDevtools initialIsOpen={false} />
        </>
      )}
    </>
  );
}

export const Route = createRootRoute({ component: Root });
